/**
 * QL-287 — Account Cash Overview (advisor entry). Reads the instance-wide
 * overview, so every placement — global or goal page — shows the same rows.
 */

import { useAccountCashOverview } from "@/lib/hooks/use-flow-instances/use-cash";
import { useUserLanguage } from "@/lib/i18n/context";
import { useT } from "@/lib/i18n/use-t";
import { useRegionalFormat } from "@/lib/regional-format/context";
import type { AccountCashOverviewConfig } from "@/lib/types/flow";
import { T } from "./account-cash-overview.i18n";
import { AccountCashOverviewView } from "./account-cash-overview-view";

type AccountCashOverviewProps = {
  instanceId: string;
  config: AccountCashOverviewConfig;
};

export function AccountCashOverview({ instanceId, config }: AccountCashOverviewProps) {
  const t = useT(T);
  const { userLanguage: language } = useUserLanguage();
  const { formatNumber, formatDateTime } = useRegionalFormat();
  const { data, isLoading, error } = useAccountCashOverview(instanceId);

  if (isLoading) return null;
  if (error || !data) {
    return <p className="text-sm text-destructive">{t.failedToLoad}</p>;
  }
  return (
    <AccountCashOverviewView
      overview={data}
      config={config}
      language={language}
      fmt={formatNumber}
      formatDateTime={formatDateTime}
    />
  );
}
